export * from './client-quotation.constant';
export * from './purchase-order.constant';
import { DefaultRequestParamsInterface } from '../_common/model';

export const PaymentTerms :any = [
  '100% Down',
  '50/50',
  '30/70',
  '20/80',
  '10/90',
  'Paid on Delivery',
  'Net 15',
  'Net 30',
  'Net 20',
  'Due on Receipt',
  '25% Down, Net 30 Upon Delivery',
  '25% Down, Net 45 Upon Delivery',
  '25% Down, Net 60 Upon Delivery',
  '25% Down, Net 90',
  'Due on Delivery',
];

export const DefaultPageSizeOptionsConstant :number[] = [5, 10, 25, 100];
export const DefaultRequestParamsConstant :DefaultRequestParamsInterface = {
  limit: 20,
  page: 1,
};

export enum ClientPurchaseOrderDiscountCodesConstant {
  STANDARD = 'STANDARD',
  CREDIT_MEMO = 'CREDIT_MEMO',
}
export interface UserPermissionCode {
  ReadWriteExecute :number;
  Read :number;
  Write :number;
  Execute :number;
}

export const UserPermissionCodeConstant :UserPermissionCode = {
  ReadWriteExecute: 7,
  Read: 1,
  Write: 2,
  Execute: 4,
};

export class FileTypeConstant {
  public static PDF :string = 'pdf';
  public static CSV :string = 'csv';
  public static XLSX :string = 'xlsx';
}

export enum InventoryStockType {
  PENDING = 'qty_pending',
  ONHAND = 'qty_onhand',
  AVAILABLE = 'qty_available',
}

export const B2BClientInvoicesAdvancedFilters :string[] = [
  'date',
  'date_from',
  'date_to',
  'payment_term',
  'payment_status',
  'po_tag',
  'sales_rep_assignees',
  'staffs',
];

export const B2BRequestForQuotesDateVariables :string[] = [
  'startCreatedDate',
  'endCreatedDate',
  'startExpectedDate',
  'endExpectedDate',
];

export const B2BQuotationsDateVariables :string[] = [
  'date_created_from',
  'date_created_to',
  'expiry_date_from',
  'expiry_date_to',
];

export enum StockSortingType {
  ASC = 'asc',
  DESC = 'desc',
}

export enum SkuStockSortType {
  PARENT = 'parent',
  VARIANT = 'variant',
}
